import { render, staticRenderFns } from "./kong.vue?vue&type=template&id=5a5093a9&"
import script from "./kong.vue?vue&type=script&lang=js&"
export * from "./kong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports